// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.con-rec-container {
  font-family: 'Arial', 'Helvetica', 'Sans-serif';
  cursor: auto;
  box-sizing: border-box;
  container-type: inline-size;
  width: 100%;
  height: 100%;
}

.con-rec {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.con-rec-header {
  text-align: left;
  border-bottom: 1px solid var(--border-line);
  padding-left: 24px;
  padding-right: 24px;
}

.con-rec-header-title {
  font-size: 16px;
  font-weight: 700;
  line-height: 24px;
  color: var(--text-subheader);
}

.con-rec-dropdown {
  display: flex;
  height: 36px;
  background-color: #74748014;
  padding-left: 24px;
  padding-right: 24px;
}

.con-rec-ctry-dropdown,
.con-rec-rating-dropdown {
  flex: 1;
}

.con-rec-table-container {
  position: relative;
  flex: 1 1 auto;
  min-height: 0;
  overflow: auto;
}

.con-rec-rating-btn-group {
  display: flex;
}

.con-rec-rating-btn {
  box-sizing: border-box;
  padding: 9px 8px;
  border: none;
  background-color: transparent;

  font-weight: 400;
  font-size: 12px;
  line-height: 20px;
}

.con-rec-rating-btn:hover {
  background-color: rgba(0, 0, 0, 0.12);
}

.con-rec-rating-btn.selected {
  background-color: #141526;
  color: #ffffff;
}

/* Loading and Error States */
.con-rec-loading-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: #f8f9fa;
  border: 1px solid #e9ecef;
  border-radius: 4px;
  height: 100%;
}

.con-rec-loading-spinner {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative;
}

.con-rec-empty-text {
  margin-top: 20px;
  font-family: 'Arial', 'Helvetica', 'Sans-serif';
  font-weight: 700;
  font-style: Bold;
  font-size: 20px;
  line-height: 28px;
  letter-spacing: 0px;
  text-align: center;
  vertical-align: middle;
  color: var(--text-subheader);
}

@keyframes pulse {
  0%,
  100% {
    opacity: 1;
  }
  50% {
    opacity: 0.5;
  }
}

.con-rec > .pagination {
  margin-top: auto;
  flex: 0 0 auto;
}

.con-rec-whitespace {
  height: 24px;
}

@container (min-width: 768px) {
  .con-rec-header {
    padding-left: 32px;
    padding-right: 32px;
  }

  .con-rec-dropdown {
    gap: 4px;
    padding-left: 32px;
    padding-right: 32px;
  }

  .con-rec-ctry-dropdown {
    flex: none;
    width: 139px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Widgets/ConsensusRecommendationWidget/ConsensusRecommendationWidget.css"],"names":[],"mappings":"AAAA;EACE,+CAA+C;EAC/C,YAAY;EACZ,sBAAsB;EACtB,2BAA2B;EAC3B,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,2CAA2C;EAC3C,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,2BAA2B;EAC3B,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;;EAEE,OAAO;AACT;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,YAAY;EACZ,6BAA6B;;EAE7B,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA,6BAA6B;AAC7B;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,+CAA+C;EAC/C,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,sBAAsB;EACtB,4BAA4B;AAC9B;;AAEA;EACE;;IAEE,UAAU;EACZ;EACA;IACE,YAAY;EACd;AACF;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE;IACE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,QAAQ;IACR,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,UAAU;IACV,YAAY;EACd;AACF","sourcesContent":[".con-rec-container {\n  font-family: 'Arial', 'Helvetica', 'Sans-serif';\n  cursor: auto;\n  box-sizing: border-box;\n  container-type: inline-size;\n  width: 100%;\n  height: 100%;\n}\n\n.con-rec {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n}\n\n.con-rec-header {\n  text-align: left;\n  border-bottom: 1px solid var(--border-line);\n  padding-left: 24px;\n  padding-right: 24px;\n}\n\n.con-rec-header-title {\n  font-size: 16px;\n  font-weight: 700;\n  line-height: 24px;\n  color: var(--text-subheader);\n}\n\n.con-rec-dropdown {\n  display: flex;\n  height: 36px;\n  background-color: #74748014;\n  padding-left: 24px;\n  padding-right: 24px;\n}\n\n.con-rec-ctry-dropdown,\n.con-rec-rating-dropdown {\n  flex: 1;\n}\n\n.con-rec-table-container {\n  position: relative;\n  flex: 1 1 auto;\n  min-height: 0;\n  overflow: auto;\n}\n\n.con-rec-rating-btn-group {\n  display: flex;\n}\n\n.con-rec-rating-btn {\n  box-sizing: border-box;\n  padding: 9px 8px;\n  border: none;\n  background-color: transparent;\n\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 20px;\n}\n\n.con-rec-rating-btn:hover {\n  background-color: rgba(0, 0, 0, 0.12);\n}\n\n.con-rec-rating-btn.selected {\n  background-color: #141526;\n  color: #ffffff;\n}\n\n/* Loading and Error States */\n.con-rec-loading-container {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  background-color: #f8f9fa;\n  border: 1px solid #e9ecef;\n  border-radius: 4px;\n  height: 100%;\n}\n\n.con-rec-loading-spinner {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  position: relative;\n}\n\n.con-rec-empty-text {\n  margin-top: 20px;\n  font-family: 'Arial', 'Helvetica', 'Sans-serif';\n  font-weight: 700;\n  font-style: Bold;\n  font-size: 20px;\n  line-height: 28px;\n  letter-spacing: 0px;\n  text-align: center;\n  vertical-align: middle;\n  color: var(--text-subheader);\n}\n\n@keyframes pulse {\n  0%,\n  100% {\n    opacity: 1;\n  }\n  50% {\n    opacity: 0.5;\n  }\n}\n\n.con-rec > .pagination {\n  margin-top: auto;\n  flex: 0 0 auto;\n}\n\n.con-rec-whitespace {\n  height: 24px;\n}\n\n@container (min-width: 768px) {\n  .con-rec-header {\n    padding-left: 32px;\n    padding-right: 32px;\n  }\n\n  .con-rec-dropdown {\n    gap: 4px;\n    padding-left: 32px;\n    padding-right: 32px;\n  }\n\n  .con-rec-ctry-dropdown {\n    flex: none;\n    width: 139px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
